import {
  Box,
  Grid,
  GridItem,
  Text,
  Flex,
  Icon,
  Image,
  Button,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from '@chakra-ui/react';
import { AiOutlineCalendar } from 'react-icons/ai';
import moment from 'moment';
import PrettyRating from 'pretty-rating-react';
import BoxPemateri from '../../../components/Pengetahuan/BoxPemateri';
import { AiOutlineClockCircle } from 'react-icons/ai';
import ListTemaPengetahuan from '../../../components/Pengetahuan/ListTema';
import ReviewPengetahuan from '../../../components/Pengetahuan/Review';
import ReviewDiskusiTabs from '../../../components/Pengetahuan/ReviewDiskusiTabs';
import { PengetahuanItem } from '../../../../types/pengetahuan';

type Props = {
  pengetahuanItem: PengetahuanItem | null;
  handleOpenModal: () => void;
};

const PengetahuanInfo = ({ pengetahuanItem, handleOpenModal }: Props) => {
  const colors = {
    star: ['#FFDA6A', '#FFDA6A', '#434b4d'],
  };

  const showListPemateriSync =
    pengetahuanItem?.status_pengetahuan === 'menunggu' &&
    pengetahuanItem?.jenis_pengetahuan === 'synchronized' &&
    !pengetahuanItem?.is_klinik_khusus;

  const showListPemateriSyncIsKlinikKhusus =
    pengetahuanItem?.status_pengetahuan === 'menunggu' &&
    pengetahuanItem?.jenis_pengetahuan === 'synchronized' &&
    pengetahuanItem?.is_klinik_khusus &&
    pengetahuanItem?.tipe_klinik_khusus === 'SUB';

  const showListPemateriAsync =
    pengetahuanItem?.status_pengetahuan === null &&
    pengetahuanItem?.jenis_pengetahuan === 'asynchronized';

  return (
    <>
      <Grid templateColumns="repeat(8, 1fr)" gap={{ base: 3, md: 5 }}>
        <GridItem colSpan={{ base: 8, md: 3 }}>
          <Image
            src={pengetahuanItem?.thumbnail}
            w="full"
            h="250px"
            rounded="xl"
            objectFit="cover"
            alt={`image-${pengetahuanItem?.title}`}
          />
        </GridItem>
        <GridItem colSpan={{ base: 8, md: 5 }}>
          <Box rounded="xl" w="full" h="full" p={4} bg="green.700">
            <Text fontSize="2xl" fontWeight="semibold" color="white" mb={3}>
              {pengetahuanItem?.title}
            </Text>
            <Text color="white" fontSize="sm" mb={3}>
              {pengetahuanItem?.nama_penyelenggara ?? ''}
            </Text>
            <Flex flexDirection={{ base: 'column', md: 'row' }}>
              <Flex mr={4}>
                <PrettyRating
                  value={pengetahuanItem?.rata_rata_rating ?? 0}
                  colors={colors.star}
                />
                <Text color="white" fontSize="sm" mx={2}>
                  {pengetahuanItem?.rata_rata_rating}
                </Text>
                <Text color="white" fontSize="sm">
                  ({pengetahuanItem?.review_count}{' '}
                  <Text color="gray.200" as="span" fontSize="sm">
                    reviews
                  </Text>
                  )
                </Text>
              </Flex>
              <Flex mt={{ base: 2, md: 0 }}>
                {pengetahuanItem?.jenis_pengetahuan === 'asynchronized' ? (
                  <>
                    <Icon
                      as={AiOutlineCalendar}
                      color="#FFDA6A"
                      boxSize={5}
                      mr={2}
                    />
                    <Text fontSize="sm" color="white">
                      {pengetahuanItem?.created_at}
                    </Text>
                  </>
                ) : (
                  <>
                    <Icon
                      as={AiOutlineCalendar}
                      color="#FFDA6A"
                      boxSize={5}
                      mr={2}
                    />
                    <Text fontSize="sm" color="white">
                      {moment(pengetahuanItem?.jadwal_mulai).format(
                        'DD MMMM YYYY HH:mm'
                      )}{' '}
                      -{' '}
                      {moment(pengetahuanItem?.jadwal_selesai).format(
                        'DD MMMM YYYY HH:mm'
                      )}
                    </Text>
                  </>
                )}
              </Flex>
            </Flex>
            {/* non klinik khusus */}
            {pengetahuanItem?.status_pengetahuan === null &&
              !pengetahuanItem?.is_klinik_khusus && (
                <Button
                  bg="orange.300"
                  color="white"
                  _hover={{ bg: 'orange.400' }}
                  _active={{ bg: 'orange.400' }}
                  mt={4}
                  onClick={handleOpenModal}
                >
                  {pengetahuanItem.jenis_pengetahuan === 'synchronized' &&
                  pengetahuanItem?.status_pengetahuan === null
                    ? 'Daftar'
                    : 'Ikuti'}
                </Button>
              )}
            {/* non klinik khusus - sudah daftar / menunggu */}
            {pengetahuanItem?.status_pengetahuan === 'menunggu' &&
              !pengetahuanItem?.is_klinik_khusus && (
                <Button
                  mt={4}
                  bg="orange.300"
                  color="white"
                  _hover={{ bg: 'orange.300' }}
                  _active={{ bg: 'orange.300' }}
                  isDisabled
                  _disabled={{
                    opacity: 1,
                    cursor: 'not-allowed',
                  }}
                >
                  Anda Telah Terdaftar
                </Button>
              )}
            {/* klinik khusus */}
            {pengetahuanItem?.is_klinik_khusus &&
              pengetahuanItem?.tipe_klinik_khusus === 'UTAMA' &&
              pengetahuanItem?.pengetahuan_approval_peserta?.is_approved !==
                true && (
                <Button
                  bg="orange.300"
                  color="white"
                  _hover={{ bg: 'orange.400' }}
                  _active={{ bg: 'orange.400' }}
                  mt={4}
                  onClick={handleOpenModal}
                  isDisabled={
                    pengetahuanItem?.pengetahuan_approval_peserta
                      ?.is_approved === null ||
                    pengetahuanItem?.pengetahuan_approval_peserta
                      ?.is_approved === false
                  }
                >
                  {(() => {
                    if (!pengetahuanItem?.pengetahuan_approval_peserta) {
                      return 'Daftar';
                    } else if (
                      pengetahuanItem?.pengetahuan_approval_peserta
                        ?.is_approved === null
                    ) {
                      return 'Menunggu persetujuan';
                    } else if (
                      !pengetahuanItem?.pengetahuan_approval_peserta
                        ?.is_approved
                    ) {
                      return 'Ditolak';
                    }

                    return 'Daftar';
                  })()}
                </Button>
              )}
          </Box>
        </GridItem>
      </Grid>

      {/* Alert Messages */}
      {pengetahuanItem?.is_klinik_khusus &&
        pengetahuanItem?.tipe_klinik_khusus === 'UTAMA' &&
        pengetahuanItem?.pengetahuan_approval_peserta?.is_approved ===
          false && (
          <Alert status="error" mt={4} borderRadius="lg" mb={1}>
            <Flex>
              <AlertIcon />
              <Box>
                <AlertTitle fontWeight={'normal'}>
                  Pengajuan Verifikasi ditolak.
                </AlertTitle>
                <AlertDescription>
                  <b>
                    Alasan Ditolak:{' '}
                    {
                      pengetahuanItem?.pengetahuan_approval_peserta
                        ?.reason_reject
                    }
                  </b>
                </AlertDescription>
              </Box>
            </Flex>
          </Alert>
        )}

      {pengetahuanItem?.tipe_klinik_khusus === 'SUB' &&
        !pengetahuanItem?.parent?.pengetahuan_approval_peserta_exists && (
          <Alert status="error" mt={4} borderRadius="lg" mb={1}>
            <Flex>
              <AlertIcon />
              <Box>
                <AlertTitle fontWeight={'normal'}>
                  Anda tidak dapat mengikuti pengetahuan ini! silakan lanjutkan
                  dengan mengikuti pengetahuan utama terlebih dahulu.
                </AlertTitle>
              </Box>
            </Flex>
          </Alert>
        )}

      <Grid templateColumns="repeat(7, 1fr)" gap={5}>
        <GridItem colSpan={{ base: 7, md: 4 }}>
          {(showListPemateriAsync ||
            showListPemateriSync ||
            showListPemateriSyncIsKlinikKhusus) &&
            pengetahuanItem?.pengetahuan_materi && (
              <Box rounded="lg" w="full" p={4} bg="white" mt={4}>
                <Text fontSize="lg" fontWeight="semibold">
                  Ikuti Pemateri
                </Text>
                {pengetahuanItem?.pengetahuan_materi.map((item, i) => (
                  <BoxPemateri key={i} item={item} />
                ))}
              </Box>
            )}
          <Box rounded="lg" w="full" p={4} bg="white" mt={4}>
            <Flex alignItems="center">
              <Text fontSize="lg" fontWeight="semibold" mr={2}>
                Informasi Umum
              </Text>
            </Flex>
            <Flex alignItems="center" mt={2}>
              <Icon as={AiOutlineClockCircle} boxSize={4} mr={2} />
              <Text fontSize="sm">
                {moment(
                  pengetahuanItem?.created_at,
                  'YYYY-MM-DD HH:mm:ss'
                ).fromNow()}
              </Text>
            </Flex>
            <Box
              mt={4}
              as="div"
              dangerouslySetInnerHTML={{
                __html: pengetahuanItem?.description || '',
              }}
            ></Box>
          </Box>
        </GridItem>
        <GridItem colSpan={{ base: 7, md: 3 }}>
          {pengetahuanItem?.is_klinik_khusus && (
            <ListTemaPengetahuan
              data={
                pengetahuanItem?.tipe_klinik_khusus === 'UTAMA'
                  ? pengetahuanItem?.children ?? []
                  : pengetahuanItem?.parent
                  ? [pengetahuanItem?.parent]
                  : []
              }
              type={pengetahuanItem?.tipe_klinik_khusus}
              total={pengetahuanItem?.children_count}
              hideButton={
                pengetahuanItem?.tipe_klinik_khusus === 'UTAMA' &&
                pengetahuanItem?.pengetahuan_approval_peserta?.is_approved ===
                  false
                  ? true
                  : false
              }
            />
          )}
          {pengetahuanItem?.jenis_pengetahuan === 'synchronized' ? (
            <ReviewDiskusiTabs readOnlyDiskusi={true} />
          ) : (
            <ReviewPengetahuan />
          )}
        </GridItem>
      </Grid>
    </>
  );
};

export default PengetahuanInfo;
